import * as t from './actionTypes';
import { InboxMetadata, InAppDisplaySettings } from './types';

export const previewTemplate = ({
  templateId,
  messageMedium,
  showAndroid,
  showExpanded,
  showLighthouseVersion,
  locale,
}: {
  templateId: number;
  messageMedium: string;
  showAndroid?: boolean;
  showExpanded?: boolean;
  showLighthouseVersion?: boolean;
  locale?: string;
}) => ({
  type: t.PREVIEW_TEMPLATE_REQUEST,
  templateId,
  messageMedium,
  showAndroid,
  showExpanded,
  showLighthouseVersion,
  locale,
});

export const previewTemplateResponse = (
  templateId: number,
  html: string,
  key: string,
  activePushDeviceWrapper?: string,
) => ({
  type: t.PREVIEW_TEMPLATE_RESPONSE,
  activePushDeviceWrapper,
  html,
  key,
  templateId,
});

export const previewTemplateError = (templateId: number) => ({
  type: t.PREVIEW_TEMPLATE_ERROR,
  templateId,
});

export const getInAppContent = (templateId: number) => ({
  type: t.GET_IN_APP_CONTENT_REQUEST,
  templateId,
});

export const getInAppContentResponse = (
  templateId: number,
  inAppDisplaySettings: InAppDisplaySettings,
  inboxMetadata: InboxMetadata,
) => ({
  type: t.GET_IN_APP_CONTENT_RESPONSE,
  templateId,
  inAppDisplaySettings,
  inboxMetadata,
});

export const getInAppContentError = () => ({
  type: t.GET_IN_APP_CONTENT_ERROR,
});

export const setActivePushDeviceWrapperState = (
  templateId: number,
  activePushDeviceWrapper: string,
) => ({
  type: t.SET_ACTIVE_PUSH_DEVICE_WRAPPER_STATE,
  templateId,
  activePushDeviceWrapper,
});
